import { PermissionArrayType } from '../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';

export const didPermissions: PermissionArrayType = {
  CREATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
    ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
  ],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
    ...getAllPermissionRolesForUserLevel('customer'),
  ],
  UPDATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
    ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
  ],
  DELETE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
    ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
  ],
};

export const didE911Permissions: PermissionArrayType = {
  CREATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
  ],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
    ...getAllPermissionRolesForUserLevel('customer'),
  ],
  UPDATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
  ],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin],
};

export const dnisFullPermissions: PermissionArrayType = {
  CREATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
  ],
  READ: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud')],
  UPDATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
    ...getAllPermissionRolesForUserLevel('customer', ['owner', 'admin']),
  ],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
};

export const didRoutingPermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin', 'user']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']),
  ],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin],
};
